import { useEffect, useState } from "react"

export const useFull = (el : any) => {
  const [fullScreen, setFullScreen] = useState(false)
  const revert = () => {
    if (!document.fullscreenElement) {
      setFullScreen(false)
      document.removeEventListener('fullscreenchange', revert)
    }
  }
  useEffect(() => {
    if (fullScreen) {
      const elem = el.current
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
        document.addEventListener('fullscreenchange', revert)
      } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
        document.addEventListener('fullscreenchange', revert)
      } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
        document.addEventListener('fullscreenchange', revert)
      }
    }
    return () => {
      document.removeEventListener('fullscreenchange', revert)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullScreen])
  return [fullScreen, setFullScreen] as const
}
